import React, { useState, useEffect, useContext } from "react";
import MUIDataTable from "mui-datatables";
import { useBot } from "../../hooks/test/useBot";
import useCeo from "../../hooks/useCEO";
import { formatDate } from "../../helpers/formatDate";
import { Spinner } from "../../components/Spinner";
import excelDownload from "../../assets/img/excel.png";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Swal from "sweetalert2";
import Excel from "exceljs/dist/exceljs";
import { saveAs } from "file-saver";
import { faFileExcel } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AuthContext } from "../../context/authContext/authContext";

const initialStateFormCalendario = {
  dateCalendar: "",
  dateCalendarfin: "",
};

export const Historico = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [form, setForm] = useState(initialStateFormCalendario);
  const [notificacionData, setNotificacionData] = useState([]);
  const { user } = useContext(AuthContext);

  const columns = [
    { header: "Unidad", key: "unidad" },
    { header: "Telefono", key: "telefono" },
    { header: "Fecha/Hora(Petición)", key: "fecha_hora_peticion" },
    { header: "Cedis", key: "cedis" },
    { header: "Operador", key: "tripulante" },
    { header: "Apertura confirmada", key: "apertura_confirmada" },
    { header: "Coordenadas", key: "coordenadas"},
    { header: "Accion", key: "accion" },
    { header: "Tipo", key: "tipo" },
  ];

  const workSheetName = `Aperturas del bot`;

  const workbook = new Excel.Workbook();

  const saveExcel = async () => {
    try {
      const fileName = `bot_del_${form.dateCalendar}_al_${form.dateCalendarfin}`;

      // creating one worksheet in workbook
      const worksheet = workbook.addWorksheet(workSheetName);

      // add worksheet columns
      // each columns contains header and its mapping key from data
      worksheet.columns = columns;

      // updated the font for first row.
      worksheet.getRow(1).font = { bold: true };

      // loop through all of the columns and set the alignment with width.
      worksheet.columns.forEach((column) => {
        column.width = column.header.length + 5;
        column.alignment = { horizontal: "center" };
      });

      // loop through data and add each one to worksheet
      notificacionData.forEach((singleData) => {
        worksheet.addRow(singleData);
      });

      // loop through all of the rows and set the outline style.
      worksheet.eachRow({ includeEmpty: false }, (row) => {
        // store each cell to currentCell
        const currentCell = row._cells;

        // loop through currentCell to apply border only for the non-empty cell of excel
        currentCell.forEach((singleCell) => {
          // store the cell address i.e. A1, A2, A3, B1, B2, B3, ...
          const cellAddress = singleCell._address;

          // apply border
          worksheet.getCell(cellAddress).border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        });
      });

      // write the content using writeBuffer
      const buf = await workbook.xlsx.writeBuffer();

      // download the processed file
      saveAs(new Blob([buf]), `${fileName}.xlsx`);
    } catch (error) {
      console.error("<<<ERRROR>>>", error);
      console.error("Something Went Wrong", error.message);
    } finally {
      // removing worksheet's instance to create new one
      workbook.removeWorksheet(workSheetName);
    }
  };

  const handleChange = (event) => {
    setForm({
      ...form,
      [event.target.name]: event.target.value,
    });
  };
  const consultarDatos = async (event) => {
    event.preventDefault();
    setLoading(true);
    let resp = await descargarNotificaciones({
      "fecha_inicio": form.dateCalendar,
      "fecha_fin":form.dateCalendarfin
    }, user.negocio_id);
    setLoading(false);
    if (resp.ok) {
      setNotificacionData(resp.notificacionHistorico);

      if (!resp) {
        Swal.fire({
          title: `No existen registros`,
          text: resp.msg,
          icon: "info",
        });
      }
    }
  };
  const columnsTable = [
    "Unidad",
    "Teléfono",
    "Fecha/Hora(Petición)",
    "Cedis",
    "Operador",
    "Apertura confirmada",
    "Coordenadas",
    "Accion",
    "Tipo",
  ];

  const options = {
    selectableRows: "none",
    downloadOptions: {
      filename: "historico-notificaciones.csv",
      // separator: ";",
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayedRowsOnly: true,
      },
      CharacterData: "utf-8",
      CharSet: "utf-8",
    },
    onDownload: (buildHead, buildBody, columnsTable, data) => {
      return "\uFEFF" + buildHead(columnsTable) + buildBody(data);
    },
    textLabels: {
      body: {
        noMatch: "No se encontraron registros",
        toolTip: "Ordenar",
        columnHeaderTooltip: (column) => `Ordenar por ${column.label}`,
      },
      pagination: {
        next: "Página siguiente",
        previous: "Página anterior",
        rowsPerPage: "Filas por página:",
        displayRows: "de",
      },
      toolbar: {
        search: "Buscar",
        downloadCsv: "Descargar CSV",
        print: "Imprimir",
        viewColumns: "Ver columnas",
        filterTable: "Filtro de tabla",
      },
      filter: {
        all: "TODOS",
        title: "FILTROS",
        reset: "LIMPIAR",
      },
      viewColumns: {
        title: "Mostrar columnas",
        titleAria: "Mostrar/Ocultar columnas de tabla",
      },
      selectedRows: {
        text: "Fila(s) seleccionada(s)",
        delete: "Remover",
        deleteAria: "Fila seleccionada removida",
      },
    },
  };

  useCeo({
    title: "Historico de Notificaciones",
    description: "Página de log notificaciones",
  });
  const { notificacionHistorico, descargarNotificaciones } = useBot();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    getHistoricoLog();
  }, []);
  const getHistoricoLog = async () => {
    setLoading(true);
    let resp = await notificacionHistorico(user.negocio_id);
    if (resp.ok) {
      let array = [];
      resp.notificacionHistorico.map((registro) => {
        const {
          unidad,
          telefono,
          fecha_hora_peticion,
          cedis,
          tripulante,
          apertura_confirmada,
          coordenadas,
          accion,
          tipo,
        } = registro;

        let aux = [
          unidad,
          telefono,
          formatDate(fecha_hora_peticion),
          cedis,
          tripulante,
          apertura_confirmada,
          coordenadas ? coordenadas : "N/A",
          accion,
          tipo,
        ];
        array.push(aux);
        return "";
      });
      setData([...array]);
    }

    setLoading(false);
  };
  return (
    <>
      {loading && <Spinner />}
      <div className="d-flex justify-content-center p-2">
        <img
          width="40px"
          title="Descargar por fecha"
          alt=""
          src={excelDownload}
          onClick={() => {
            handleShow();
          }}
        />
      </div>
      <MUIDataTable
        title={"Log-Bot"}
        data={data}
        columns={columnsTable}
        options={options}
        onDownload={(buildHead, buildBody, columnsTable, data) => {
          return "\uFEFF" + buildHead(columnsTable) + buildBody(data);
        }}
      />
      
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="sm"
      >
        <form onSubmit={consultarDatos}>
          <Modal.Header closeButton>
            <Modal.Title>Exportar Notificaciones</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {notificacionData.length === 0 ? (
              <>
              <label>rango inicio</label>
              <input
                type="date"
                className="form-control"
                name="dateCalendar"
                onChange={handleChange}
                required
              />
              <label>rango fin</label>
              <input
                type="date"
                className="form-control"
                name="dateCalendarfin"
                onChange={handleChange}
                required
              />
              </>
            ) : (
              <>
                <div className="d-flex justify-content-center">
                  <button
                    id="liberarSalida"
                    className="btn btn-block liberarSalida"
                    style={{ background: "#8FBC8F" }}
                    onClick={() => {
                      saveExcel();
                      handleClose();
                      setNotificacionData([]);
                    }}
                  >
                    <FontAwesomeIcon icon={faFileExcel} />
                    &nbsp; Descargar
                  </button>
                </div>
                <br></br>
                <b>Rango:</b> &nbsp;{form.dateCalendar} al {form.dateCalendarfin}
              </>
              // notificacionData.map((notifica, index) => {
              //   return <p key={index}> {notifica.tripulante}</p>;
              // })
            )}
          </Modal.Body>
          <Modal.Footer>
            <div className="row justify-content-center">
              <div className="col-6">
                <Button
                  className="secondary"
                  onClick={() => {
                    setNotificacionData([]);
                    handleClose();
                  }}
                >
                  Cancelar
                </Button>
              </div>
              <div className="col-6">
                {notificacionData.length === 0 ? (
                  <Button
                  className="primary"
                    onClick={() => {
                      // handleClose();
                    }}
                    type="submit"
                  >
                    Confirmar
                  </Button>
                ) : (
                  ""
                )}
              </div>
            </div>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};
